
<v-card-actions class="pb-4">
    <slot name="pre"></slot>

    <v-btn
        v-if   = "showDelete"
        class  = "dialog-button mr-1"
        @click = "onDelete"
        depressed
    >
        {{ deleteLabel }}
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn
        v-if   = "showCancel"
        class  = "dialog-button mr-0"
        @click = "onCancel"
        depressed
    >
        {{ $t('common.cancel') }}
    </v-btn>
    <v-btn
        v-if   = "showSave"
        class  = "dialog-button primary pl-3 pr-3"
        @click = "onSave"
        depressed
    >
        {{ storeLabel }}
    </v-btn>
</v-card-actions>
